var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wang-editor"}},[_c('div',{attrs:{"id":"editor—wrapper"}},[_c('div',{attrs:{"id":"toolbar-container"}}),_c('div',{attrs:{"id":"editor-container"}})]),_c('link',{attrs:{"href":"https://unpkg.com/@wangeditor/editor@latest/dist/css/style.css","rel":"stylesheet"}})])
}]

export { render, staticRenderFns }